import * as Yup from 'yup';

const newRegistro = {
    objetivoProdutor: null,
    outroObjetivoProdutor: '',
    comoConheceuAgrare: null,
    outroComoConheceuAgrare: '',
    multiFarm: false,
    unifiedControl: false,
    fazendas: [{
        nomeFazenda: "",
        localidade: "",
        latitude: null,
        longitude: null,
        areaTotal: null,
        areaUnidade: 1,
        tipoAreaPropriedade: null,
    }],
    nomeConta: "",
    atividadeAgricola: "CULTIVO_GRAOS",
    localTrabalho: "PROPRIEDADE_RURAL",
    culturas: [],
    outrasCulturas: [],
};

const validation = [
    Yup.object({
        objetivoProdutor: Yup.string()
            .typeError('Este campo é obrigatório')
            .required('Este campo é obrigatório'),
        outroObjetivoProdutor: Yup.string()
            .when("objetivoProdutor", {
                is: "OUTRO",
                then: Yup.string().required("Por favor, nos conte mais sobre seu objetivo."),
                otherwise: Yup.string().notRequired(),
            }),
        comoConheceuAgrare: Yup.string()
            .typeError('Este campo é obrigatório')
            .required('Este campo é obrigatório'),
        outroComoConheceuAgrare: Yup.string()
            .when("comoConheceuAgrare", {
                is: "OTHER",
                then: Yup.string().required("Por favor, nos conte mais sobre seu objetivo."),
                otherwise: Yup.string().notRequired(),
            }),
        multiFarm: Yup.boolean().required("Por favor, selecione uma opção"),
    }),
    Yup.object({
        fazendas: Yup.array().of(
            Yup.object().shape({
                nomeFazenda: Yup.string()
                    .min(2, 'O campo deve ter no mínimo 2 caracteres')
                    .max(60, 'Campo deve ter menos do que 60 caracteres')
                    .required('Este campo é obrigatório'),
                localidade: Yup.string()
                    .required('Este campo é obrigatório'),
                areaTotal: Yup.number()
                    .positive('Por Favor, informe um valor maior que zero')
                    .transform(value => (isNaN(value) ? 0.0 : value))
                    .required('Este campo é obrigatório'),
                areaUnidade: Yup.string()
                    .typeError('Este campo é obrigatório')
                    .required('Este campo é obrigatório'),
                tipoAreaPropriedade: Yup.string()
                    .typeError('Este campo é obrigatório')
                    .required('Este campo é obrigatório'),
            })
        ),
        atividadeAgricola: Yup.string()
            .typeError('Este campo é obrigatório')
            .required('Este campo é obrigatório'),
        localTrabalho: Yup.string()
            .typeError('Este campo é obrigatório')
            .required('Este campo é obrigatório'),
        nomeConta: Yup.string()
            .when(['multiFarm', 'unifiedControl'], {
              is: (multiFarm, unifiedControl) => multiFarm && !unifiedControl,
              then: Yup.string()
                .min(2, 'O nome da conta deve ter no mínimo 2 caracteres')
                .max(60, 'O nome da conta deve ter menos de 60 caracteres')
                .required('O nome da conta é obrigatório'),
              otherwise: Yup.string().notRequired()
            }),
    }),
    Yup.object({
        culturas: Yup.array().min(1, "Selecione pelo menos uma cultura"),

        outrasCulturas: Yup.array().when("culturas", {
            is: culturas => culturas.includes("outros"),
            then: Yup.array()
                .of(
                    Yup.object().shape({
                        nome: Yup.string()
                            .required("O nome da cultura é obrigatório")
                            .min(2, "O nome deve ter pelo menos 2 caracteres"),
                        unidadeId: Yup.string()
                            .required("A unidade de colheita é obrigatória"),
                    })
                )
                .min(1, "Adicione pelo menos uma cultura se selecionar 'outros'"),
            otherwise: Yup.array().notRequired(),
        }),
    }),
];


export const onBoardingNovaConta = {
    newRegistro,
    validation
}
